import { orderImageIdsForJump } from "./jumpLoadOrder";

/**
 * Fix A — prioritize the jumped-to slice.
 *
 * On a finding-click the destination series streams 0->N by default, so the
 * clicked slice (often deep in the series) isn't decoded for seconds. Warming a
 * small target-first window into the cornerstone image cache the instant the
 * click happens makes those frames cache-hits when the volume/stack loads, so
 * the clicked slice (and a little scroll room around it) shows immediately while
 * the rest of the series streams in the background.
 *
 * Pure but for the injected `load` (the actual cornerstone prefetch), so the
 * window selection is unit-tested in isolation. `orderImageIdsForJump` only
 * reorders FETCH order, never volume geometry — safe for both paths.
 *
 * @returns the image ids that were warmed (target-first order), for logging/tests.
 */
export async function warmJumpTarget(params: {
  imageIds: readonly string[];
  sliceIndex: number;
  frames: number;
  load: (imageIds: string[]) => Promise<unknown>;
}): Promise<string[]> {
  const window = Math.max(0, Math.floor(params.frames));
  if (window === 0) return [];
  const ordered = orderImageIdsForJump(params.imageIds, params.sliceIndex).slice(0, window);
  if (ordered.length === 0) return [];
  await params.load(ordered);
  return ordered;
}
